const menuList = [
  {
    path: '/show',
    name: 'show',
    meta: {
      title: "风潮由我艺术展",
      menuPath: "/show",
    },
    component: () => import("../views/Show.vue"),

  },
  {
    path: "/contestDetail",
    name: "contestDetail",
    meta: {
      title: "赛事详情",
      menuPath: "/contestDetail",
    },
    component: () => import("../views/contestDetail.vue"),
  },
  {
    path: "/designReward",
    name: "designReward",
    meta: {
      title: "获奖公示",
      menuPath: "/designReward",
    },
    component: () => import("../views/designReward.vue"),
  },
  {
    path: "/contestInformation",
    name: "contestInformation",
    meta: {
      title: "赛事资讯",
      menuPath: "/contestInformation",
    },
    component: () => import("../views/contestInformation.vue"),
  },
  {
    path: "/freeThemeWorks",
    name: "freeThemeWorks",
    meta: {
      title: "自由主题作品",
      menuPath: "/freeThemeWorks",
    },
    component: () => import("../views/themeWorks.vue"),
  },
  {
    path: "/themeWorks",
    name: "themeWorks",
    meta: {
      title: "主题作品",
      menuPath: "/themeWorks",
    },
    component: () => import("../views/themeWorks.vue"),
  },
  
];

export default menuList;
